import styled from 'styled-components';
import { Link } from "react-router-dom";

export const GroupDetailSection = styled.div`
    padding : calc(100vw*(11/375)) calc(100vw*(17/375)) calc(100vw*(25/375));
    border-bottom: calc(100vw*(14/375)) solid #f7f7f7;
`
export const Title = styled.h1`
    font-size: calc(100vw*(23/375));
    font-weight: bold;
    padding-bottom: calc(100vw*(11/375));
`
export const Description = styled.div`
    & > a {
        color: blue;
        text-decoration: underline; 
    }

    font-size:  ${props=> props.fontsize};
    line-height: 1.5;
    color: #4e4e4e;
    white-space: pre-wrap;
    word-break: break-all;
`
export const DescriptionSummary = styled.div`
    & > a {
        color: blue;
        text-decoration: underline; 
    }

    font-size:  ${props=> props.fontsize};
    line-height: 1.5;
    color: #4e4e4e;
    white-space: pre-wrap;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const ShowMoreBtnWrapper = styled.div`
    padding-bottom: calc(100vw*(24/375));
    &:after {
        display: block;
        content: " ";
        clear:both;
    }
`;
export const ShowMoreBtn = styled.span`
    float:right;
    font-size: calc(100vw*(14/375));
    color:#989898;
`;

export const ProfileLink = styled(Link)`
`
export const ProfileImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
export const Btnlist = styled.div`
    display: flex;
    justify-content: space-between;
`

export const Btn = styled(Link)`
    width: calc(100vw*(342/375));
    height: calc(100vw*(44/375));
    border-radius: calc(100vw*(3/375));
    background-color: #ebebeb;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    line-height: calc(100vw*(44/375));
    text-align: center;
    color: #4e4e4e;
`
export const BtnNum = styled.span`
    font-size: calc(100vw*(12/375));
    font-weight: bold;
    letter-spacing: 0.24px;
    color: #4e4e4e;
    margin-left: calc(100vw*(2/375));
`
export const Num = styled.span`
    margin-left: calc(100vw*(5/375));
    font-weight: bold;
    color: #4e4e4e;
    font-size: calc(100vw*(12/375));
`
export const Userpf = styled.div` 
    display: flex;
    align-items: center;
    margin-bottom : calc(100vw*(9/375));
` 
export const Userimg = styled.span`
    width: calc(100vw*(38/375));
    height: calc(100vw*(38/375));
    border-radius: 50%;
    overflow: hidden;
    margin-right :calc(100vw*(8/375));
    border: solid calc(100vw*(1/375)) #c6c6c6;
`

export const CrownIcon = styled.span`
    display: inline-block;
    width: calc(100vw*(16/375));
    height: calc(100vw*(13/375));

`
export const Crowntit = styled.span`
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    color: #707070;
    margin-left : calc(100vw*(2.4/375));
`
export const Name = styled.span`
    font-size: calc(100vw*(14/375));
    font-weight: bold;
    color: #414141;
    margin-left : calc(100vw*(5.5/375));
`